import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

export interface ConfirmModalProps {
    children: any; isShowingModal: boolean;
    resetModalState?: any; okClick?: any; modelTitle?:
    string; okayBtnText?: string; cancelBtnText?: string;
}

const ConfirmModal = (props: ConfirmModalProps) => {
    const [showConfirmPopup, setShowConfirmPopup] = useState(props.isShowingModal);

    useEffect(
        () => (
            setShowConfirmPopup(props.isShowingModal)
        ),
        [props.isShowingModal]
    );
    const onClickConfirmCancel = () => {
        props.resetModalState(false);
        setShowConfirmPopup(false);
    }
    const onClickConfirmOK = () => {
        setShowConfirmPopup(false);
        props.okClick();
    }


    return (
        <Modal show={showConfirmPopup} backdrop="static" centered >
            <Modal.Header>
                <Modal.Title>{props.modelTitle ? props.modelTitle : "Confirmation Message"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-justify">
                {props.children}
            </Modal.Body>
            <div className="border-top mt-4 p-3">
                <Button className="btn-block-xs-only float-right" variant="primary"
                    onClick={() => onClickConfirmOK()}>{props.okayBtnText ? props.okayBtnText : "Okay"}</Button>
                <Button onClick={() => onClickConfirmCancel()} className="btn-block-xs-only float-right mr-sm-3"
                    variant="secondary">{props.cancelBtnText ? props.cancelBtnText : "Cancel"}</Button>
            </div>
        </Modal>
    )
}

export { ConfirmModal };